import React, { useEffect, lazy, Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminCacheProvider } from '../context/AdminCacheContext';
import { SidebarProvider } from '../context/SidebarContext';
import SidebarContainer from '../components/common/SidebarContainer';
import ContentContainer from '../components/common/ContentContainer';
import SoporteView from '../components/common/SoporteView';
import '../styles/global-sidebar.css';

// Lazy loading de componentes
const OrganizationsManagement = lazy(() => import('../components/admin/OrganizationsManagement'));
const PersonsManagement = lazy(() => import('../components/admin/PersonsManagement'));
const AcademicContentManagement = lazy(() => import('../components/admin/AcademicContentManagement'));
const AcademicScheduleManagement = lazy(() => import('../components/admin/AcademicScheduleManagement'));
const UsersManagement = lazy(() => import('../components/admin/UsersManagement'));

// Componente de carga
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Cargando...</span>
    </Spinner>
  </div>
);


// Componente principal del AdminView
const AdminView = () => {
  useEffect(() => { document.title = 'Artemis — Administrador'; }, []);

  return (
    <SidebarProvider>
      <AdminCacheProvider>
        <div className="global-layout">
          <SidebarContainer />
          
          <ContentContainer>

          <div className="global-content-body">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Navigate to="/admin/organizations" replace />} />
                <Route path="/organizations" element={<OrganizationsManagement />} />
                <Route path="/persons" element={<PersonsManagement />} />
                <Route path="/users" element={<UsersManagement />} />
                <Route path="/academic-content" element={<AcademicContentManagement variant="admin" />} />
                <Route path="/academic-schedule" element={<AcademicScheduleManagement />} />
                <Route path="/soporte" element={<SoporteView />} />
              </Routes>
            </Suspense>
          </div>
        </ContentContainer>
      </div>
      </AdminCacheProvider>
    </SidebarProvider>
  );
};

export default AdminView;